import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {

  constructor() { }

  public static readonly APIs = {
    apiurl: environment.apiUrl,
    endPoints: {
      ITEM: {
        GET_SUGGESTION: '/Item/GetSuggestion',
        FILTER_ITEMS: '/Item/FilterItems',
        GET_ITEM_DETAILS: '/Item/GetItemDetails',
        GET_FINISHES_NEW: '/Item/GetFinishesNew',
        GET_COMMONLY_ORDER: '/Item/GetCommonOrderedItem',
        GET_ASSOCIATE_ITEM: '/Item/GetCommonOrderedItem',
        SAVE_ASSOCIATE_ITEM: '/Item/SaveCommonOrderedItem',
        DISASSOCIATE_ITEM: '/Item/SaveCommonOrderedItem',
        DELETE_ITEM: '/Item/DeleteItemCatalog',
      },
      MACRO: {
        GET_ALL: '/macro/getAll',
        GET_V6MACROS: '/macro/GetV6Macros',
        ADD: '/macro/add',
        UPDATE: '/macro/update',
        MACROS_BY_ID: '/macro/MacrosById',
        DELETE: '/macro/Delete',
      },
      CART: {
        GET_ITEMS: '/cart/GetItems',
        ADD_ITEM: '/Cart/AddItem',
        ADD_STOCK_ITEM: '/Cart/AddStockItem',
        ADD_CONFIGURED_ITEM_TO_CART: '/Cart/AddConfiguredItemToCart',
        UPDATE_ITEM: '/Cart/UpdateItem',
        REMOVE_ITEM: '/Cart/RemoveItem',
        EMPTY_CART: '/Cart/EmptyCart',
        UPLOAD_ITEMS: '/cart/uploadItems',
        GET_CART_ITEM_COUNT: '/cart/ItemCountInCart',
        GET_CART_DISCOUNT: '/MasterData/GetCartDiscount',
        GET_CART_MIN_ORDER_FEE: '/OrderFees/GetCartMinimumOrderFee',   
        GET_CART_PROMO_CODE_FEE: '/PromoCode/GetCartPromoCodeFee',
      },
      FREIGHT_CLAIM: {
        GET_MY_SHIPPED_ORDERS: "/freightClaim/getMyShippedOrders",
      },
      ORDER: {
        CONFIRM_CHECKOUT: '/order/checkout',
        EXPRESS_CHECKOUT: '/order/expressCheckout',
        CONFIRM_CHECKOUT_CHARGETOACCOUNT: '/order/checkoutChargeToAccount',
        EXPRESS_CHECKOUT_CHARGETOACCOUNT: '/order/expressCheckoutChargeToAccount',
        SAVE_CHECKOUT_FILE: '/order/Checkoutsave',
        SAVE_CHECKOUT_FILE_DELAY: '/order/CheckoutsaveDelay',
        VALIDATE_PROMOCODE: '/order/checkPromoCode',
        GET_MY_ORDERS: "/order/getMyOrders",
        GET_MY_ORDER_DETAILS: "/order/GetMyOrderDetail",
        GET_ORDER_INVOICE_DETAILS: "/order/GetOrderInvoiceDetail",
        GET_ORDER_SHIPMENT_DETAILS: "/order/GetOrderTrackShipment",
        GET_ORDER_DETAILS_HEADER: "/order/GetOrderDetailsHeader",
        GET_TAX_CERTIFICATES: '/order/TaxCertificatesItem',
        GET_CREDIT_CARD_CHECKOUT_REQUEST_ID: '/order/getcreditcardcheckoutrequestid',
        COMPLETE_CREDIT_CARD_CHECKOUT: '/order/CreditCardCompleteCheckOut',
        CANCEL_CREDIT_CARD_CHECKOUT: '/order/CreditCardCancelCheckOut',
        CALCULATE_FREIGHT_AMOUNT: '/order/CalculateFreight',
      },
      INVOICE: {
        GET_INVOICE: '/order/GetInvoices',
        GET_INVOICE_DETAIL: "/order/GetOrderDetailsFromInvoiceNumber", //Need to check method name
        GET_RELATED_INVOICES: "/order/RelatedInvoices",
        DOWNLOAD_INVOICE: "/order/DownloadInvoice"
      },
      MASTER_DATA: {
        GET_COUNTRIES: '/MasterData/GetCountries',
        GET_STATES: '/MasterData/GetStates',
        GET_PRICE_BOOK_CATEGORIES: '/MasterData/GetPriceBookCategories',
        GET_FINISHES: '/MasterData/GetFinishes',
        GET_REGION_CURRENCY_LIST: '/PromoCode/GetRegionCurrencyList',
        GET_PRODUCT_DETAILS: '/PromoCode/GetProductDetails',
        GET_BB_DETAILS:'/PromoCode/GetBBDetails',
        GET_MARKET_SEGMENT: '/MasterData/GetMarketSegments',
        GET_FREIGHT_TERMS: '/MasterData/GetFreightTerms',
        GET_PAINT_CODES: '/MasterData/GetPaintCodes',
        GET_ALL_SUPPORT_DATA_FOR_CHECKOUT_ORDER_DETAIL: '/MasterData/GetAllSupportDataForCheckOutOrderDetail',
      },
      PRICE_BOOK: {
        GET_CATEGORIES: '/priceBook/getCategories',
        GET_ASSOCIATED_CATEGORIES: '/priceBook/GetAssociatedCategories',
        GET_ALL_CATEGORIES: '/priceBook/getAllCategories',
      },
      USER: {
        VALIDATE_TOKEN: '/User/ValidateToken',
        GET_DETAILS: '/User/GetDetails',
        LOGIN: '/User/Login',
        GET_NEW_TOKEN: '/User/Refresh',
        DELETE_REFRESH_TOKEN: '/User/DeleteRefresh',
        CREDIT_INFO: '/Customer/GetCardInfo',
        NEW_USER: '/User/Register',
        VALID_USERNAME: '/User/IsUserNameAvailable',
        CHANGE_PASSWORD: '/User/ChangePassword',
        CHANGE_DEFAULT_PASSWORD: '/User/ChangePassword',
        FORGOT_PASSWORD: '/User/ForgotPassword',
        CONFIRM_FORGOT_PASSWORD_OTP: '/User/ConfirmForgotPasswordOtp',
        ACCEPT_TERM_CONDITION: '/User/UpdateUserTermsandContitions',
        GET_ALL_USERS: "/User/GetAll",
        GET_USER_BY_CUSTOMER_NUMBER: '/User/GetUserByCustomerNumber',
        GET_USERS_FOR_TRANSFER_QUOTE: '/User/GetUsersForTransferQuote',
        GET_WORKLIST_USERS: "/User/GetWorkListUsers",
        DELETE_USER: "/User/DeleteUser",
        UPDATE_USER: "/User/UpdateUser", //no reference for this
        ADD_USER: "/User/AddUser",
        GET_ALLROLES: "/User/GetAllRoles",
        GET_EDIT_USER_DETAILS: "/User/GetUserDetailsByUserId",
        PWA_LOGIN_LOG: '/User/SavePWAUserLog',
        Fetch_Freight_Estimate_Flag: '/User/FetchFreightEstimateFlag',
        Fetch_Freight_Estimate_Note_Flag: '/User/FetchFreightEstimateNoteFlag',
        Get_Text_Version: '/User/GetTextVersion'
      },
      CUSTOMER: {
        GET_ADDRESS: '/Customer/GetAddress',
        GET_ORDER_INVOICE_ADDRESS: '/Customer/GetCustomerAddress',
        ADD_SHIPPING_ADDRESS: '/Customer/AddShippingAddress',
        ARCHIVE_ADDRESS: '/Customer/ArchiveAddress',
        IS_DEFAULT_ADDRESS: '/Customer/isDefaultAddress',
        GET_SUGGESTION: '/Customer/GetSuggestion',
        //GET_ORDER_INVOICE_ADDRESS: '/Customer/GetCustomerDetailsFromCustomerNumber',
        GET_MULTIPLIER_PLAN: '/CUSTOMER/GetMultiplierPlanNew',
        ACCOUNT_SUMMARY: '/Customer/GetAccountSummary',
        GET_ALLCUSTOMERS: '/Customer/GetAllCustomers',
        GET_ALLCUSTOMERS_FOR_ADMIN: '/Customer/GetAllCustomersForAdmin'
      },
      PRODUCT_ATTRIBUTE: {
        GET_ALL: '/ProductAttribute/GetAll',
        GET_ALL_V6ATTRIBUTES: '/ProductAttribute/GetAllV6Attributes',
        GET: '/ProductAttribute/Get',
        ADD_ATTRIBUTE: '/ProductAttribute/Add',
        UPDATE_ATTRIBUTE: '/ProductAttribute/Update',
        ATTRIBUTE_BY_ID: '/ProductAttribute/AttributesById',
        DELETE_ATTRIBUTE: '/ProductAttribute/Delete',

      },
      JOB: {
        SEARCH: '/job/search'
      },
      PRODUCT: {
        GET_ALL_CATEGORIES: '/Product/GetAllCategories',
        GET_CONFIGURATION: '/Product/GetConfiguration',
        GET_KWIKKEYCONFIGURATION: '/Product/GetKwikKeyConfiguration',
        COPY_CONFIGURATION: '/Product/CopyConfiguration',
        GET_PRODUCT_DETAILS: '/Product/GetProductDetails',
        GET_KWIKKEY_PRODUCT_DETAILS: '/Product/GetKwikkeyProductDetails',
        GET_PRODUCT_DEPENDENCIES: '/Product/GetProductDependencies',
        GET_PRODUCTS_BY_CATEGORYID: '/Product/GetProductsByCategoryId',
        CREATE_CONFIGURATION: '/Product/CreateConfiguration',
        UPDATE_ONLY_CONFIGURATION: '/Product/UpdateOnlyConfiguration',
        UPDATE_CONFIGURATION: '/Product/updateConfiguration',
        GET_PRODUCT_CONFIG_IMG: '/Product/GetProductConfigImage',
        GET_ALL_PRODUCT_TEMPLATE: '/Product/GetAllProductTemplate',
        CREATE_PRODUCT_TEMPLATE: '/Product/CreateProductTemplate',
        EDIT_PRODUCT_TEMPLATE: '/Product/EditProductTemplate',
        //manageTranslation
        GET_OptionTranslation: '/Product/GetOptionTranslations',
        GET_OptionValueTranslation: '/Product/GetOptionValueTranslations',
        CREATE_OptionTranslation: '/Product/CreateOptionTranslation',
        CREATE_OptionValueTranslation: '/Product/CreateOptionValueTranslation',
        EDIT_OptionTranslation: '/Product/CreateOptionTranslation',
        GET_ProductCode: '/Product/GetTranslationFamilies',
        //product details/config
        GET_PRODUCT_CONFIG_FORPRODUCT: '/ProductConfig/GetAllProductConfigForProduct',
        DELETE_OPTION_TRANSLATOR: '/Product/DeleteOptionTranslation',
        DELETE_OPTION_VALUE_TRANSLATOR: '/Product/DeleteOptionValueTranslation',
        DELETE_PRODUCT_CATEGORY: '/Admin/DeleteProductCategory',
        DELETE_PRODUCT_SUB_CATEGORY: '/Admin/DeleteProductSubCategory',
        DELETE_PRODUCT_CONFIGURATION: '/Admin/DeleteProductConfiguration',
        DELETE_PRODUCT_TEMPLATE: '/Product/DeleteProductTemplate',

      },
      QUOTE: {
        GET_KD_QUOTE: "/Quote/GetKdQuotes",
        GET_QUOTE_MIN_ORDER_FEE: '/OrderFees/GetQuoteMinimumOrderFee',
        GET_QUOTE_PROMO_CODE_FEE: '/PromoCode/GetQuotePromoCodeFee',
        UPDATE_KD_QUOTE_STATUS: "/Quote/UpdateQuoteByStatus",
        GET_KD_QUOTE_DETAIL: "/Quote/GetKdQuoteItems",
        ADD_KD_QUOTE: "/Quote/CreateQuote",
        CREATE_CONFIGURE_PRODUCT_QUOTE: "/Quote/CreateConfigureProductQuote",
        DELETE_KD_QUOTE: "/Quote/DeleteKdQuote",
        Update_KD_QUOTE_HEADER: "/Quote/UpdateKdQuote",
        DELETE_KD_QUOTE_ITEM: "/Quote/DeleteKdQuoteItem",
        COPY_KD_QUOTE: "/Quote/CopyKdQuote",
        ADD_QUOTE_TO_CART: "/Quote/addQuoteToCart",
        ADD_CONFIGURED_ITEM_TO_QUOTE: "/Quote/AddConfiguredItemToQuote",
        ADD_QUOTE_ITEM_TO_CART_ITEM_LIST: "/Quote/AddQuoteItemToCart",
        EMPTY_KD_QUOTE_ITEMS: "/Quote/EmptyKdQuoteItems",
        ADD_ITEM_TO_KD_QUOTE_ITEM_LIST: "/Quote/AddStockItemToQuote",
        ADD_Cart_ITEM_TO_KD_QUOTE: "/Quote/AddCartItemToKdQuote",
        CREATE_QUOTE_ITEM_REVISION: "/Quote/CreateKdQuoteRevision",
        PRINT_MATERIAL_PROPOSAL: "/Quote/PrintMaterialProposal",
        PRINT_INHOUSE_MATERIAL_PROPOSAL: "/Quote/PrintInHouseMaterialProposal",
        GET_ALL_INHOUSE_QUOTES: "/Quote/InhouseQuotes",
        REQUEST_A_QUOTE: "/Quote/QuoteRequest",//Need to follow standard name format
        REQUEST_A_FACTORY_QUOTE: "/Quote/RequestAFactoryQuote",//Need to follow standard name format
        QUOTE_DETAIL_PAYLOAD: "/Quote/QuoteDetailPayload",
        REQUEST_A_FACTORY_QUOTE_PAYLOAD: "/Quote/requestAFactoryQuotePayload",
        REQUEST_A_QUOTE_PAYLOAD: "/Quote/requestAQuotePayload",
        GET_USER_FOR_TRANSFER_QUOTE: '/Quote/GetUserForTransferQuote',
        UPDATE_QUOTE_USER: "/Quote/UpdateQuoteUser",
        UPDATE_ITEM_TO_KD_QUOTE: "/Quote/UpdateKdQuoteItem",
        CREATE_QUOTE: "/Quote/CreateQuote",
        UPLOAD_ITEMS: "/Quote/UploadQuoteItem",
        GET_KD_QUOTE_WITH_ITEM_COUNT: "/Quote/GetKdQuotesWithItemCount",
        GET_KD_QUOTE_LOCK_STATUS: "/Quote/CheckQuoteLockStatus",
      },
      MANAGE_COMPANY: {
        GET_USER_ACCOUNT: '/Customer/GetUsersByCustomer',
        SAVE_NEW_USER: '/Customer/SaveNewUser',
        UPDATE_USER_ACCOUNT: '/Customer/UpdateUserAccount',
        UPDATE_USER_ACCESS_TO_SCREENS: '/Customer/UpdateUserAccessRequest',
        RESET_USER_PASSWORD:'/Customer/ResetUserPassword'
      },
      SELF_UTILITY: {
        GET_CREDIT_REFERENCE: "/SelfUtility/GetCreditReference",
        GET_FINISH_CATEGORIES: "/SelfUtility/GetFinishCategories",
        GET_SAMPLE_FINISHES: "/SelfUtility/GetSampleFinishes",
        GET_GRID_DATA_BY_CATEGORY: "/SelfUtility/getSampleGridDataByCategories",
        PLACE_SAMPLE_REQUEST: "/SelfUtility/SampleRequestPlaceOrder",
        DOWNLOAD_LIEN_RELEASE: "/SelfUtility/DownloadLienRelease",
        GET_LIEN_RELEASE_DETAILS: "/SelfUtility/GetDetailsbyInvoiceNumber",
        THERMAL_CALCULATE_PAYLOAD: "/SelfUtility/GetThermalCalculatorData",
        GET_PROJECT_SERIES: "/SelfUtility/GetThermalProductSeries",
        THERMAL_CALCULATE: "/SelfUtility/CalculateThermalVision",
      },
      SUBMITTALPACKAGE: {
        GET_ARCHITECTURE_DETAILS: '/SubmittalPackage/GetDetails',
        GET_REPORT_ALL_DATA: '/SubmittalPackage/GetDetailedTestReportFromProductType',
        DOWNLOAD_SUBMITTAL: '/SubmittalPackage/DownloadSubmittalPackage',
        // DOWNLOAD_SUBMITTAL: '/SubmittalPackage/DownloadSubmittalPackagePdf',
        GET_TERMS_AND_CONDITIONS: '/SubmittalPackage/GetTermsAndConditons',
        SAVE_TERMS_AND_CONDITIONS: '/SubmittalPackage/SaveTermsAndConditions'
      },
      GENERATEWARRANTY: {
        GET_DETAILS_OF_SERVICE_ORDER: "/GenerateWarranty/GetDetailsOfServiceOrder",
        GET_ORDERS_FOR_WARRANTY: "/GenerateWarranty/GetAllOrdersForWarranty",
        DOWNLOAD_WARRANTY: "/GenerateWarranty/DownloadWarranty"
        // DOWNLOAD_WARRANTY: "/GenerateWarranty/DownloadWarrantyPdf"
      },
      KAWNEER_ADMIN: {
        GET_LANGUAGE_TRANSLATION: "/LanguageTranslation/GetComponentNameList",
        SAVE_CONTROL_NAME: "/LanguageTranslation/SaveControlText",
        GET_ERROR_LIST: "/Admin/GetErrorList",
        GET_ITEM_CATALOG: "/Item/GetItemCatalog",
        SAVE_ITEM_CATALOG: "/Item/SaveItemCatalog",
      },
      MARKETING_ADMIN: {
        GET_PROMO_CUSTOMER_LIST:"/PromoCode/GetPromoCustomerList",
        GET_ARCHITECTURE_DETAILS: "/Admin/GetArchitecturalDetailSubCategory",
        GET_CATEGORY: "/Admin/GetArchitectureDetailCategory",
        SAVE_ARCHITECTURE_CATEGORY: "/Admin/SaveArchitectureCategory",
        SAVE_ARCHITECTURE_DETAILS: "/Admin/SaveSubCategory",
        GET_TEST_REPORT: "/Admin/GetTestReportDetails",
        SAVE_TEST_SUB_CATEGORY: "/Admin/SaveTestSubCategory",
        SAVE_TEST_CATEGORY: "/Admin/SaveTestCategory",
        SAVE_TEST_REPORT: "/Admin/SaveTestReport",
        GET_SAMPLE_FINISHES: "/Admin/GetSampleFinishes",
        SAVE_SAMPLE_FINISH_CATEGORY: "/Admin/AddSampleFinishCategory",
        SAVE_SAMPLE_FINISH_SUB_CATEGORY: "/Admin/AddSampleFinishSubCategory",
        GET_BROADCAST_MESSAGE: "/Admin/GetBroadcastMessageList",
        SAVE_BROADCAST_MESSAGE: "/Admin/AddBroadcastMessage",
        GET_PROMO_CODE: "/PromoCode/GetPromoCodes",
        SAVE_PROMO_CODE: "/PromoCode/SavePromoCodes",
        GET_OUTAGE_SCHEDULE: "/Admin/GetOutageSchedules",
        SAVE_OUTAGE_SCHEDULE: "/Admin/SaveOutageSchedules",
        GET_OUTAGEOBJ: "/Admin/CheckOutage",
        GET_IMAGES: "/Admin/GetImages",
        GET_BANNER_IMAGES: "/Admin/GetHomeBannerImages",
        SAVE_IMAGES: "/Admin/SaveImages",
        GET_AMDIN_BANNER_IMAGES: "/Admin/GetAdminBannerImages",
        SAVE_AMDIN_BANNER_IMAGES: "/Admin/SaveAdminBannerImages",
        DELETE_AMDIN_BANNER_IMAGES: "/Admin/DeleteAdminBannerImages",
        SAVE_TRAINING_PAGES_DESCRIPTION: "/Training/SaveTrainingDetails",
        GET_TRAINING_PAGES_DESCRIPTION: "/Training/GetTrainingDetails",
        SAVE_MECHANICS_SCHOOL: "/Training/SaveMechanicsSchool",
        SAVE_MODULES_SCHOOL: "/Training/SaveModulesSchool",
        DELETE_MODULES_SCHOOL_MODULE: "/Training/DeleteModulesSchoolModule",
        DELETE_MODULES_SCHOOL_LOCATION: "/Training/DeleteModulesSchoolLocation",
        DELETE_MECHANICS_SCHOOL_LOCATION: "/Training/DeleteMechanicsSchoolLocation",
        GET_SURVEY_DETAILS: "/Admin/GetSurveyQuestions",
        SAVE_SURVEY_DETAILS: "/Admin/SaveSurveyQuestions",
        SAVE_SURVEY_ENTRY: "/Admin/SaveSurvey",
        GET_NEWS_DETAILS: "/Literature/GetDocuments",
        SAVE_NEWS_DETAILS: "/Literature/SaveLiteratureDocuments",
        UPDATE_NEWS_DETAILS: "/Literature/UpdateLiteratureDocuments",
        SAVE_PRODUCT_CONFIGURATION: "/Admin/SaveProductConfiguration",
        GET_PRODUCT_MAPPING: "/Admin/GetProductMapping",
        GET_PRODUCT_CATEGORY: "/Admin/GetProductCategoryMapping",
        //product category
        SAVE_PRODUCT_CATEGORY: "/Admin/AddEditProductCategory",
        SAVE_PRODUCT_SUB_CATEGORY: "/Admin/AddEditProductSubCategory",
        GET_USER_SURVEY_DETAILS: "/Admin/GetUserSurveyQuestions",

        DELETE_SAMPLE_FINISH_SUB_CATEGORY: "/Admin/DeleteSampleFinishSubCategory",
        DELETE_IMAGES: "/Admin/DeleteImages",
        DELETE_PROMO_CODE: "/PromoCode/DeletePromoCodes",
        UPDATE_PROMO_CODES: '/PromoCode/UpdatePromoCodes',
        GET_AUTO_GENERATE_PROMO_CODE: '/PromoCode/GetAutoGeneratePromoCodes',
        GET_FINISHES: '/MasterData/GetFinishes',
        DELETE_OUTAGE_SCHEDULE: "/Admin/DeleteOutageSchedules",
        DELETE_SURVEY: "/Admin/DeleteSurveyQuestions",
        DELETE_BROADCAST_MESSAGE: "/Admin/DeleteBroadCastMessage",
        DELETE_NEWS_DETAILS: "/Literature/DeleteLiteratureDocuments",
        DELETE_ARCHITECTURE_DETAILS: "/Admin/DeleteSubCategory",
        DELETE_TEST_REPORT: "/Admin/DeleteTestReport",

      },
      //#Region Product Sample Fulfillment
      PRODUCT_SAMPLE_FULFILLMENT_ADMIN: {
        GET_SAMPLE_SUB_CATEGORIES: "/ProductSampleFulfillment/GetSampleSubCategories",
        ADD_SAMPLE_CATEGORY: "/ProductSampleFulfillment/AddSampleCategory",
        UPDATE_SAMPLE_CATEGORY: "/ProductSampleFulfillment/UpdateSampleCategory",
        DELETE_SAMPLE__SUB_CATEGORY: "/ProductSampleFulfillment/DeleteSampleSubCategory",
        ADD_UPDATE_SAMPLE_SUB_CATEGORY: "/ProductSampleFulfillment/AddUpdateSampleSubCategory",
        UPDATE_INVENTORY_SAMPLE_SUB_CATEGORY: "/ProductSampleFulfillment/UpdateInventorySampleSubCategory",
        GET_SAMPLE_PRODUCT_ORDER_HEADER: "/ProductSampleFulfillment/GetAllSampleProductOrderHeaders",
        GET_SAMPLE_PRODUCT_ORDER_DETAILS: "/ProductSampleFulfillment/GetSampleProductOrderDetailsByHeader",
        GET_ALL_SAMPLE_SUBCATEGORY_COST_BY_SUBCATEGORY_ID: "/ProductSampleFulfillment/GetAllSampleSubCategoryHistoryById",
        GET_SAMPLE_REORDER_REPORT: "/ProductSampleFulfillment/GetAllSampleReorderReport",
        GET_SAMPLE_USAGE_REPORT: "/ProductSampleFulfillment/GetAllSampleUsageReport",
        GET_SAMPLE_SUB_CATEGORY_EXIST: "/ProductSampleFulfillment/GetSingleSampleSubCategoryExist",
        //#Region user place order
        GET_ACTIVE_SAMPLE_CATEGORIES: '/ProductSampleFulfillment/GetActiveSampleCategories',
        GET_ACTIVE_SAMPLE_SUB_CATEGORIES_BY_CATEGORY: '/ProductSampleFulfillment/GetActiveSampleSubCategoriesByCategory',
        GET_SAMPLE_REGIONS: '/ProductSampleFulfillment/GetAllSampleRegions',
        PLACE_ORDER_SAMPLE_REQUEST: "/ProductSampleFulfillment/SampleProductRequestPlaceOrder",        
        GET_SAMPLE_ADMIN_BUDGET_REPORT: "/ProductSampleFulfillment/GetSampleAdminBudgetReport",
        GET_SAMPLE_ADMIN_BUDGET_ALLOCATION_REPORT: "/ProductSampleFulfillment/GetSampleAdminBudgetAllocationReport",
        ADD_SAMPLE_ADMIN_BUDGET_ASSOCIATION: "/ProductSampleFulfillment/AddSampleAdminBudgetAssociation",
        DELETE_SAMPLE_ADMIN_BUDGET_ASSOCIATION: "/ProductSampleFulfillment/DeleteSampleAdminBudgetAssociation", 
      },
      // #End Region 
      LANGUAGE_TRANSLATION: {
        GET_LANGUAGE_TEXT: "/LanguageTranslation/GetLabelTextByLanguageCode",
        GET_LANGUAGES: "/LanguageTranslation/GetLanguages"

      },
      SCHOOL_AND_TRAINING: {
        // GET_CUSTOMER_SPECIFIC_SCHOOL: "/Training/GetCustomerSpecificSchool",
        GET_MECHANICS_SCHOOL: "/Training/GetMechanicsSchool",
        REGISTER_MECHANICS_SCHOOL: "/Training/SaveMechanicsSchoolRegistration",
        //SAVE_MECHANICS_SCHOOL: "/Training/SaveMechanicsSchool",
        //SAVE_MODULES_SCHOOL: "/Training/SaveModulesSchool",
        GET_MODULES_SCHOOL: "/Training/GetModulesSchool",
        REGISTER_MODULES_SCHOOL: "/Training/SaveModulesSchoolRegistration",
      },
      LITERATURE: {
        GET_LITERATURE_DOCUMENT_PAGES: "/Literature/GetLiteratureDocumentGroups",
        GET_LITERATURE_DETAILS: "/Literature/GetLiteratureDocuments",
        GET_LITERATURE_DETAILS_ADMIN: "/Literature/GetLiteratureDocumentsAdmin",
        APPROVE_DOCUMENT_ADMIN: "/Literature/ApproveDocumentsAdmin",
        DOWNLOAD_FILE:"/Literature/DownloadFilesForItem"
      },
      FOOTER_PAGES: {
        SAVE_CONTACT_US_DETAILS: "/Footer/InsertContactUsDetails",
        GET_FAQ_DETAILS: "/LanguageTranslation/GetLabelTextByLanguageCode",
      },
      V6TRANSLATIONS: {
        GET_OPTIONS: "/Product/GetOptionTranslations",
        GET_OPTION_VALUES: "/Product/GetOptionValueTranslations",
      },
      UPLOAD: {
        UPLOAD_FILES_KENDO: "/Admin/UploadFile",
        REMOVE_FILES_KENDO: "/Admin/RemoveFile"
      }
    }
  };

}
